import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import config from '../../config'
import Loader from 'react-loader'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
import { asyncConnect } from 'redux-async-connect'
import container from '../../helpers/container'
import * as searchActions from 'redux/modules/search'
const Styles = require('./FundRedirect.css')

@connect(
  state => ({ result: state.shareClass.result,
    loading: state.shareClass.loading, loaded: state.shareClass.loaded, error: state.shareClass.error }),
  searchActions)

@asyncConnect([{
  deferred: true, // need otherwise cient navigate is blocked until the page is loaded
  promise: ({params, store: {dispatch, getState}}) => {
    return dispatch(searchActions.shareClassDetails(params.fundId, params.investmentVehicleId))
  }
}])
@CSSModules(Styles, {allowMultiple:true})
export default class FundRedirect extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.object
  }
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  componentDidMount() {
  }
  componentWillReceiveProps(nextProps) {
  }
  componentWillUnmount() {
  }
  render() {
    if( !this.props.result ){
      return (
        <div styleName="main">
          <Loader options={{scale: 0.70, top:'2.0rem'}} loaded={ false }/>
        </div>
      )
    } else if ( this.props.result && (this.props.result.fund && this.props.result.shareClass) ) {
      const shareClass = this.props.result.shareClass
      const fund = this.props.result.fund
      const ticker = shareClass.ticker ? shareClass.ticker : 'N'
      const name = format.sanitize(fund.name)
      const urlStart = config.routes.fund+'/'+name+'/'+ticker
      const urlEnd = shareClass.fund_id+'/'+shareClass.investment_vehicle_id
      const fossilsUrl = urlStart+'/gender-lens-score/'+urlEnd
      const url = config.domain+config.routes.fund+'/'+shareClass.fund_id+'/'+shareClass.investment_vehicle_id
      this.context.router.push(fossilsUrl)
      return (
        <div styleName="main">
          {container.helmet(shareClass.fund_legal_name, '', url)}
        </div>
      )
    } else {
      this.context.router.push(config.routes.notFound)
      return (
        <div styleName='main'>
          <Loader options={{scale: 0.70, top:'2.0rem'}} loaded={ false }/>
        </div>
      )
    }
  }
}
